import React from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from "@material-ui/icons/Menu";

import { getIcon } from "../common";

import "../styles/navStyles.css";

const useStyles = makeStyles({
    fullList: {
      width: 'auto',
    },
});

const NavDrawer = props => {
    // console.log(props);
    const classes = useStyles();
    const [state, setState] = React.useState({
        top: false,
        left: false
    });

    const menu = props.homeList;

    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setState({ ...state, [anchor]: open });
    }

    const list = (anchor, data) => (
        <div
            className={clsx(classes.list, {
                [classes.fullList]: anchor === 'top' || anchor === 'bottom',
            })}
            role="presentation"
            onClick={toggleDrawer(anchor, false)}
            onKeyDown={toggleDrawer(anchor, false)}
        >
            <List className="panel-list"
                role="presentation"
                onClick={toggleDrawer(anchor, false)}
                onKeyDown={toggleDrawer(anchor, false)}
            >
                <ListItem button key={"menu-item-Home"}>
                    <Link
                        to={{
                            pathname: "/home"
                        }}
                    >
                        <ListItemIcon >
                            {getIcon('HomeIcon')}
                        </ListItemIcon>
                        <ListItemText primary="Home" />    
                    </Link>
                </ListItem>

                <ListItem button key={"menu-item-profile"}>
                    <Link
                        to={{
                            pathname: "/profile"
                        }}
                    >
                        <ListItemIcon>
                            {getIcon('AccountCircleIcon')}
                        </ListItemIcon>
                        <ListItemText primary="Profile" />
                    </Link>
                </ListItem>

                <Divider />
                {data.map((item, index) => {
                    return (
                        <ListItem button key={`menu-item-${item.icon}-${index}`}>
                            <Link
                                to={{
                                    pathname: item.path
                                }}
                            >
                                <ListItemIcon>
                                    {getIcon(item.icon)}
                                </ListItemIcon>
                                <ListItemText primary={item.text} />    
                            </Link>
                        </ListItem>
                    )
                })}

                <Divider />
                <ListItem button key={"menu-item-settings"}>
                    <Link
                        to={{
                            pathname: "/settings"
                        }}
                    >
                        <ListItemIcon>
                            {getIcon('SettingsIcon')}
                        </ListItemIcon>
                        <ListItemText primary="App Details" />
                    </Link>
                </ListItem>

                <Divider />
                <ListItem button key={"menu-item-test-search"}>
                    <Link
                        to={{
                            pathname: "/testsearch"
                        }}
                    >
                        <ListItemIcon>
                            {getIcon('SettingsIcon')}
                        </ListItemIcon>
                        <ListItemText primary="Test Search Screen" />
                    </Link>
                </ListItem>

            </List>
        </div>
    );

    return (
        <div>
            {['left'].map((anchor) => (
                <React.Fragment key={anchor}>
                    <MenuIcon className="headerIcons"  onClick={toggleDrawer(anchor, true)} />
                    <SwipeableDrawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                    >
                        {list(anchor, menu)}
                    </SwipeableDrawer>
                </React.Fragment>
            ))}
        </div>
    )
}

const mapStateToProps = state => {
    const { auth } = state.auth;
    const { homeList } = state.data;
    return { auth, homeList };
};

const MenuDrawer = connect(mapStateToProps)(NavDrawer);

export { MenuDrawer }